<template>
  <div class="my-8">
    <!-- Header -->
    <div class="mb-10">
      <h2 class="text-3xl font-bold text-[#34495e]">
        Choose Your Payment Option
      </h2>

      <p class="mt-2 max-w-2xl text-zinc-500">
        Select your preferred payment method to complete your membership renewal
        securely and conveniently.
      </p>
    </div>

    <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <div
        v-for="option in paymentOptions"
        :key="option.id"
        class="relative flex flex-col rounded-3xl border border-zinc-200 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-orange-500 hover:shadow-xl"
      >
        <!-- Payment Type -->

        <!-- Title -->
        <h3 class="mt-5 text-2xl font-bold text-secondary">
          {{ option.title }}
        </h3>

        <!-- Description -->
        <p class="mt-3 leading-7 text-zinc-500">
          {{ option.description }}
        </p>

        <!-- Processing Time -->

        <!-- Features -->
        <ul class="mt-8 flex-1 space-y-4">
          <li
            v-for="feature in option.features"
            :key="feature"
            class="flex items-center gap-3"
          >
            <span class="h-2.5 w-2.5 rounded-full bg-orange-500"></span>

            <span class="text-sm text-zinc-700">
              {{ feature }}
            </span>
          </li>
        </ul>

        <!-- Button -->
        <router-link
          @click="selectPaymentOptionHandler(option.code)"
          :to="option.route"
          class="mt-8 block rounded-xl bg-orange-500 py-3.5 text-center font-semibold text-white transition-all duration-200 hover:bg-orange-600 hover:shadow-lg"
        >
          {{ option.buttonText }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { inject, onMounted, ref } from "vue";

export default {
  setup() {
    const store = inject("$store");
    const paymentOptions = ref([
      {
        id: 1,
        code: "one-time",
        icon: "💳",
        title: "Full Payment",
        description:
          "Pay the total subscription amount in a single transaction.",
        features: [
          "One-time payment",
          "No recurring installments",
          "Immediate payment confirmation",
          "Quick and hassle-free checkout",
        ],
        buttonText: "Continue with Full Payment",
        route: "/payment/center/payment-checkout",
      },
      {
        id: 2,
        code: "installment",
        icon: "📅",
        title: "Installment Payment",
        description:
          "Divide your subscription into smaller scheduled payments.",
        features: [
          "Flexible payment terms",
          "Multiple installment options",
          "Easier budget management",
          "Choose your preferred payment schedule",
        ],
        buttonText: "Continue with Installment",
        route: "/payment/center/payment/installment",
      },
    ]);
    onMounted(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
    const selectPaymentOptionHandler = (val) => {
      store.commit("SET_PAYMENT_OPTION", {
        selectedPaymentOption: val,
      });
    };

    return {
      paymentOptions,
      selectPaymentOptionHandler,
    };
  },
};
</script>
